import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ZohoSyncRequestAddModel } from '../models/zoho.sync.request.add.model';

@Injectable()
export class ZohoSyncRequestService {

    constructor(private http: HttpClient) { }

    syncBills(model: ZohoSyncRequestAddModel) {
        return this.http.post(`${environment.apiUrl}/api/admin/zohoSyncRequest`, model);
    }
}





